import { render, staticRenderFns } from "./BaseUserListEditorComponent.vue?vue&type=template&id=91303e2e&"
import script from "./BaseUserListEditorComponent.vue?vue&type=script&lang=ts&"
export * from "./BaseUserListEditorComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports